
  <div class="phone-testimonial testi-phone">
    <!-- phone container -->
  <app-phone>
   <div class="w-100 h-100  position-elative">
      <img [src]="media.frameUrl" alt="WeDream rules" loading="lazy" >
   </div>
 </app-phone>
 </div>